import React, { useState, useEffect, useRef } from "react";
import "./TextBox.scss";
import { Magnifier, Clock, Close } from "../../icons"; // Customize these icons

const SearchBar = ({
  data = [], // full data list to search
  onSelect, // callback when result selected
  maxRecent = 5, // max show recent searches
  size = "md", // input size
  widthSize = "md", // input width
  className = "",
  placeholder = "Search",
}) => {
  /* useStates */

  const [input, setInput] = useState(""); // contains input values
  const [focused, setFocused] = useState(false); // is search bar focused or not
  const [recent, setRecent] = useState([]); // store recent searched
  const [results, setResults] = useState([]); // store all the result

  /* end useStates */

  /* useRef */
  const wrapperRef = useRef(null);
  /* end useRef */

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setFocused(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []); // Handle clicks outside to close dropdown

  useEffect(() => {
    const inputLower = input.toLowerCase();
    let newResults = [];

    if (!input) {
      newResults = recent.map((item) => ({ ...item, isRecent: true }));
    } else {
      const recentIds = new Set(recent.map((r) => r.id));
      const filteredRecent = recent
        .filter((item) => item.label.toLowerCase().includes(inputLower))
        .map((item) => ({ ...item, isRecent: true }));

      const matchedOthers = data
        .filter(
          (item) =>
            item.label.toLowerCase().includes(inputLower) &&
            !recentIds.has(item.id)
        )
        .map((item) => ({ ...item, isRecent: false }));

      newResults = [...filteredRecent, ...matchedOthers];
    } // logic to show search result

    setResults((prevResults) => {
      const prev = JSON.stringify(prevResults);
      const next = JSON.stringify(newResults);
      return prev !== next ? newResults : prevResults;
    }); // Avoid unnecessary state update
  }, [input, data, recent]); // logic for search and the result

  const handleSelect = (item) => {
    setInput(item.label);
    setFocused(false);
    const newRecent = [item, ...recent.filter((r) => r.id !== item.id)].slice(
      0,
      maxRecent
    );
    setRecent(newRecent);
    onSelect && onSelect(item);
  }; // handel selection of result on search anything

  const handleClear = () => {
    setInput("");
    setResults(recent.map((item) => ({ ...item, isRecent: true })));
    onSelect && onSelect(null);
  }; // remove all the text typed

  return (
    <div className={`searchbar-wrapper ${size}`} ref={wrapperRef}>
      <div className="searchbar-input-wrapper">
        <div className="borderWrapper">
          <Magnifier size={size} className="search-icon" />
          <input
            type="text"
            placeholder={placeholder}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onFocus={() => setFocused(true)}
            className={`input borderInner searchbar-input ${className} ${
              widthSize ? "Width-" + widthSize : ""
            } ${size}`}
          />
          {input && (
            <Close className="clear-icon" size={size} onClick={handleClear} />
          )}
        </div>
      </div>

      {focused && results.length > 0 && (
        <div className="searchbar-dropdown">
          <div className="borderWrapper">
            <div className="borderInner">
              <div className="searchbar-list">
                {results.map((item) => (
                  <div
                    key={item.id}
                    className="searchbar-result borderWrapperJustOneCorner"
                    onClick={() => handleSelect(item)}
                  >
                    {item.isRecent ? (
                      <Clock size={size} className="result-icon" />
                    ) : (
                      <Magnifier size={size} className="result-icon" />
                    )}
                    <span className="result-label">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
